import { Subscription } from 'rxjs';
import { S3BucketName } from '../constants/s3-bucket-name';

export type TMigrationUploadFileDataType = S3BucketName;

export enum MigrationUploadFileSupplyType {
  INK = 'INK',
  PAPER = 'PAPER',
  ACCOUNTS = 'ACCOUNTS',
}

export enum MigrationUploadFileStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  UPLOAD_ERROR = 'UPLOAD_ERROR',
  PROCESSED = 'PROCESSED',
  PROCESSING_ERROR = 'PROCESSING_ERROR',
  UPLOAD_PROCESSING_ERROR = 'UPLOAD_PROCESSING_ERROR',
  UPLOADED = 'UPLOADED',
  CANCELED = 'CANCELED',
  RETRYING = 'RETRYING',
  PROCESSED_WITH_ERROR = 'PROCESSED_WITH_ERROR',
}

/**
 * Migration Upload File Model
 */
export class MigrationUploadFile {
  // prettier-ignore
  /**
   * @constructor
   */
  constructor( // NOSONAR
    public name: string,
    public dataType: TMigrationUploadFileDataType,
    public supplyType: MigrationUploadFileSupplyType,
    public status: MigrationUploadFileStatus,
    public creationDate: Date,
    public regionId: number,
    public file?: File,
    public progress?: number,
    public upload$?: Subscription,
    public downloading?: boolean,
    public requestId?: number
  ) {}
}

/**
 * PORT Points Batch Execution Model
 */
export class PortPointsExecution {
  /**
   * @constructor
   */
  constructor(
    public id: number,
    public status: string,
    public triggeredAt: Date,
    public fromDate?: Date,
    public toDate?: Date,
    public completedAt?: Date,
    public recordsFound?: number,
    public pointsMigrated?: number,
    public reportFileName?: string
  ) {}
}

/**
 * Paginated backend response
 */
export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  numberOfElements: number;
  empty: boolean;
}
